<template>
    <rkm-table
        :fields="fields"
        :items="data.model.contatos"
        hide-filters
    >
        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                @click.stop="remove(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {

        fields() {

            return [
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true
                },
                {
                    key: 'departamento',
                    label: 'Departamento',
                    sortable: true
                },
                {
                    key: 'cargo',
                    label: 'Cargo',
                    sortable: true
                },
                {
                    key: 'telefone',
                    label: 'Telefone',
                    sortable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        remove(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o contato?',
                async () => this.data.model.contatos.splice(index, 1)
            )
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>